import React from 'react';
import { CheckCircle, Award, Users, Sparkles, Globe2 } from 'lucide-react';
import { whyChooseUs } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';
import Reveal from './motion/Reveal';

const iconMap = {
  1: Award,
  2: CheckCircle,
  3: Users,
  4: Sparkles,
  5: Globe2
};

const WhyChooseUs = () => {
  const { t } = useLanguage();

  return (
    <section id="why-us" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <Reveal className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <h2 className="text-4xl font-normal text-gray-900">
            {t.whyUs.title}
          </h2>
          <div className="w-16 h-px bg-gray-900 mx-auto"></div>
        </Reveal>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((reason) => {
            const Icon = iconMap[reason.id];
            return (
              <div 
                key={reason.id}
                className="p-8 bg-gray-50 hover:bg-white hover:shadow-md transition-all duration-200 group"
              >
                <div className="space-y-4">
                  <div className="w-12 h-12 bg-gray-900 flex items-center justify-center group-hover:bg-gray-800 transition-colors duration-200">
                    <Icon size={24} className="text-white" />
                  </div>
                  
                  <h3 className="text-lg font-normal text-gray-900">
                    {reason.title}
                  </h3>
                  
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
